<template>
  <el-row>
    <el-table
      :data="recommendations.slice((form.page - 1) * form.pageSize, form.page * form.pageSize)"
      border
      style="width: 100%">
      <el-table-column
        fixed
        label="编号"
        width="150">
        <template slot-scope="scope">
          <router-link :to="{path: '/user/details', query: {id: scope.row.id}}">{{scope.row.id}}</router-link>
        </template>
      </el-table-column>
      <el-table-column
        prop="name"
        label="姓名">
      </el-table-column>
      <el-table-column
        prop="nickname"
        label="昵称">
      </el-table-column>
      <el-table-column
        prop="mobile"
        label="电话">
      </el-table-column>
    </el-table>
    <el-pagination
      class="pagination"
      v-if="totalElements > 0"
      background
      layout="prev, pager, next"
      :current-page.sync="form.page"
      :page-size="form.pageSize"
      :total="totalElements">
    </el-pagination>
  </el-row>

</template>

<script>
export default {
  name: "MyRecommendations",
  props: {
    recommendations: Array,
    totalElements: Number
  },
  data() {
    return {
      form: {
        page: 1,
        pageSize: 20
      },
    }
  },
  methods: {
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/users/recommendation/MyRecommendations.vue